/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AttributeFilter { 
    attribute?: string;
    condition?: AttributeFilter.ConditionEnum;
    value?: string;
}
export namespace AttributeFilter {
    export type ConditionEnum = 'equals' | 'not_equals' | 'contains' | 'not_contains' | 'regex' | 'not_regex' | 'set' | 'not_set';
    export const ConditionEnum = {
        Equals: 'equals' as ConditionEnum,
        NotEquals: 'not_equals' as ConditionEnum,
        Contains: 'contains' as ConditionEnum,
        NotContains: 'not_contains' as ConditionEnum,
        Regex: 'regex' as ConditionEnum,
        NotRegex: 'not_regex' as ConditionEnum,
        Set: 'set' as ConditionEnum,
        NotSet: 'not_set' as ConditionEnum
    };
}


